module.exports = __webpack_public_path__ + "media/images/home/flow_p_index_1-2c774fa9df44b1c0a787ed8b6209907d.svg";